<app-orders-nav [activeMenuItem]="'referrals'"></app-orders-nav>


<mat-card class="content-card">

  <h2>Referrals</h2>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px">
    <div>
      <!--<mat-form-field>
        <mat-label>Additional Status</mat-label>
        <mat-select [formControl]="referralSpecialStatusSelect" (selectionChange)="onReferralStatusChange()" multiple>
          <mat-option [value]="'r1'">Accepted</mat-option>
          <mat-option [value]="'r2'">Ordered</mat-option>
          <mat-option [value]="'r3'">Pending Bonus</mat-option>
          <mat-option [value]="'r4'">Completed</mat-option>
          <mat-option [value]="'r9'">Expired</mat-option>

        </mat-select>
      </mat-form-field>-->
    </div>
    <!--<div>
      <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="table" fxLayoutAlign="end center">

        <mat-form-field class="brand-filter-field"  *ngIf="!currentUserIsPartner()">
          <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                       [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
        <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                       [(ngModel)]="table.filters.endFilterDate"></app-date-edit>

        <mat-form-field class="date-filter-field">
          <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
            <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">{{dateFilter.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()"
                [disabled]="startDateFilter.invalid || endDateFilter.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>


      </div>
    </div>-->

  </div>


  <app-mat-table-generator #table
                           tableName="referralsTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           (clearingFilters)="checkAllButton()"
                           [dialogRemoveText]="dialogRemoveText"
                           [saveFilters]=true


  >
  </app-mat-table-generator>
</mat-card>
